import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import React from "react";
import { getServiceDimensionValues } from "slices/dimensions";
import { createLookupRegistry, useLookupOnce } from "common/useLookupOnce";

// Every row used to request this dimension for its own id. The dimension reducer keys
// records by type/implementor/field and ignores the id, so each response overwrote the
// previous one's values -- only the last row to answer resolved its name, and the rest
// fell back to showing the raw id. Fetch the whole dimension once and resolve locally.
const DIMENSION = { type: "kernel", implementor: "catalogue", field: "id" };
const DIMENSION_KEY = `${DIMENSION.type}-${DIMENSION.implementor}-${DIMENSION.field}`;

const registry = createLookupRegistry();

const NiceCatalogue = (props) => {
  const wantedResource = props.children;

  const dimension = useSelector((state) =>
    state.dimensions?.dimensions?.find(
      (d) =>
        d.type === DIMENSION.type &&
        d.implementor === DIMENSION.implementor &&
        d.field === DIMENSION.field
    )
  );

  const catalogue = dimension?.values?.find((entry) => entry.value === wantedResource);

  useLookupOnce(
    registry,
    DIMENSION_KEY,
    () =>
      getServiceDimensionValues({
        search: { ...DIMENSION, lookUpLabel: "<name>" },
      }),
    { resolved: !!dimension }
  );

  return <>{catalogue ? <Box>{catalogue.label}</Box> : <Box>{wantedResource}</Box>}</>;
};

export default React.memo(NiceCatalogue);
